var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      [
        _c(
          "el-form-item",
          {
            attrs: {
              label: _vm.$t.__(
                "dashboard.forms.TurnoverSettingForm.select_card_currency"
              ),
              prop: "currency"
            }
          },
          [
            _c("currency-input", {
              on: { input: _vm.updateCurrency },
              model: {
                value: _vm.form.currency,
                callback: function($$v) {
                  _vm.$set(_vm.form, "currency", $$v)
                },
                expression: "form.currency"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-form-item",
          {
            attrs: {
              label: _vm.$t.__("common.actions.select_tax_display"),
              prop: "taxMode"
            }
          },
          [
            _c(
              "el-radio-group",
              {
                model: {
                  value: _vm.form.taxMode,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "taxMode", $$v)
                  },
                  expression: "form.taxMode"
                }
              },
              [
                _c(
                  "el-radio",
                  { staticClass: "mt-2", attrs: { label: "exc" } },
                  [_vm._v(_vm._s(_vm.$l10n.__("HT")))]
                ),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c(
                  "el-radio",
                  { staticClass: "mt-3", attrs: { label: "inc" } },
                  [_vm._v(_vm._s(_vm.$l10n.__("TTC")))]
                )
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "aright mt-5" },
          [
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.cancel"),
                type: "secondary"
              },
              on: { click: _vm.close }
            }),
            _vm._v(" "),
            _c("CompassButton", {
              attrs: {
                label: _vm.$t.__("common.actions.save"),
                type: "primary"
              },
              on: { click: _vm.submitForm }
            })
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }